.icon {
  --size: 2rem;
  height: var(--size);
  width: var(--size);
  fill: currentColor;
  /* Disable pointer events - helps sentry breadcrumbs */
  pointer-events: none;
}
.icon-large {
  --size: 3rem;
}

.match-text {
  --size: 1rem;
}

.spacing-left {
  margin-left: 0.5rem;
}

.spacing-right {
  margin-right: 0.5rem;
}

.icon-facebook {
  background-repeat: no-repeat;
  border-radius: 0;
  height: 32px;
  width: 32px;
}

.icon-instagram {
  background-repeat: no-repeat;
  border-radius: 0;
  height: 32px;
  width: 32px;
}

@media (--rds-media-min-ml) {
  .match-text {
    --size: 1.125rem;
  }
}

@keyframes bounce-beat {
  10% {
    transform: scale(0.95);
  }
  20% {
    transform: scale(1.15);
  }
  30% {
    transform: scale(0.95);
  }
  40% {
    transform: scale(1.15);
  }
  50% {
    transform: scale(0.95);
  }
  60% {
    transform: scale(1);
  }
}

.animate-bounce {
  animation-name: bounce-beat;
  transform: scale(1);
  animation-duration: 1000ms;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-timing-function: ease-out;
}
